exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".o-board {\n  position: relative;\n  padding-top: 40px;\n  background-color: #f7f4f9; }\n  @media (min-width: 768px) {\n    .o-board {\n      padding-bottom: 50px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/stylesheets/components/boards.scss
// module id = 119
// module chunks = 0